<script lang="ts">
    import { WIDGET_VERSION } from "@/constants";
    import { RewardsVipTiersSingleProgressWidgetDefinition } from "@apps/rewards/constants/definitions";
    import type { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";

    import DynamicImport from "@components/DynamicImport/DynamicImport.svelte";
    import Widget from "@components/Widget.svelte";
    import type { LoggerInterface } from "@interfaces/LoggerInterface";

    //Props
    export let dynamicImportManager: DynamicImportManager;
    export let logger: LoggerInterface;
</script>

<DynamicImport
    let:value={{
        module,
    }}
    definition={RewardsVipTiersSingleProgressWidgetDefinition}
    {dynamicImportManager}
    shouldImportModule
>
    {#if module}
        <Widget
            class="gw-rd-vip-tiers-single-progress-widget-container"
            widget={module}
            params={[
                {
                    isWidgetShadowRootEnabled: true,
                    widgetVersion: WIDGET_VERSION.V1,
                },
                logger,
            ]}
        />
    {/if}
</DynamicImport>
